
export default {
  name: 'AtomLegalLinks',
  props: {
  },
  computed: {
    generalConfig() {
      return this.$store?.state?.base?.meta?.generalConfig
    },
    cookieBotEnabled() {
      return this.generalConfig?.cookiebotEnabled || false
    },
    legalLinks() {
      return this.generalConfig?.legalLinks || []
    },
    legalImages() {
      return this.generalConfig?.legalImages || []
    },
  },
  methods: {
    showCookieSettings() {
      if (window.Cookiebot) {
        window.Cookiebot.show();
      }
    },
    resourceUrl(img) {
      if (img.includes('://')) {
        return img
      }
      return `${this.$store.getters.cdnBase}/${img}`
    }
  }
}
